import React from "react";

import Arrow from "@common/assets/images/logs-arrow.svg";
import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { getActivityHistoryCellStyle, isCellError } from "@common/components/ShakeTable/ui/activityHistory/DomainCell";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { iconForLog, messageForLog } from "@main/pages/shared/components/ActivityHistoryTable/ActivityHistoryHelpers";
import { CellContext } from "@tanstack/react-table";

interface MessageCellProps {
  // eslint-disable-next-line
  info: CellContext<LogUnionRowItem, any>;
}

const MessageCell = ({ info }: MessageCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {iconForLog(item, isError)}
      {messageForLog(item, isError)}
      {info.row.getIsSelected() && (
        <img
          src={Arrow}
          style={{
            position: "absolute",
            right: "-281rem",
            height: "2.2rem",
            zIndex: 1,
          }}
        />
      )}
    </BaseCell>
  );
};

export { MessageCell };
